import React from "react";

// Define props for MainLayout - only children needed now
interface Props {
  children: React.ReactNode;
}

export function MainLayout({ children }: Props) {
  return (
    // Main layout container - Sidebar is removed
    // Adjusted height to h-full as h-screen might conflict with TopNavBar's height
    <div className="flex h-full bg-gray-100 dark:bg-gray-900">
      {/* Sidebar is no longer rendered here */}
      <main className="flex-grow w-full">
        {/* AppProvider passes the page content here */}
        {children}
      </main>
    </div>
  );
}
